import styled from 'styled-components';

interface OpenProps {
    open: boolean;
}

// TODO: do poprawki do MUI Button
export const StyledButton = styled.button<OpenProps>`
    display: flex;
    flex-direction: row;
    justify-content: ${({open}) => (open ? 'flex-start' : 'center')};
    align-items: center;
    padding: 8px;
    color: inherit;
    gap: ${({open}) => (open ? '6px' : '0')};
    width: ${({open}) => (open ? '240px' : '50px')};
    min-height: 34px;
    border: none;
    border-radius: 20px;
    background: transparent;
    cursor: pointer;
    overflow: hidden;

    span {
        display: ${({open}) => (open ? 'inline' : 'none')};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex-grow: 1;
        text-align: left;
        font-size: ${({theme}) => theme.typography.body2.fontSize};
        font-weight: ${({theme}) => theme.typography.body2.fontWeight};
        font-family: ${({ theme }) => theme.typography.fontFamily};
    }

    div:first-child {
        margin-left: ${({open}) => (open ? '0' : 'auto')};
        margin-right: ${({open}) => (open ? '0' : 'auto')};
    }
`;

export const StyledInput = styled.input`
    border: none;
    outline: none;
    background: transparent;
    color: inherit;
    font: inherit;
    width: 100%;
    padding: 2px 4px;
    border-radius: 4px;
`;

export const OptionsButton = styled.button`
    margin-left: auto;
    cursor: pointer;
    background: none;
    border: none;
    align-items: center;
    justify-content: center;
    padding: 4px;
    visibility: hidden;
    opacity: 0.5;
    transition: opacity 0.2s ease;
    position: relative;
    top: 1px;

    svg {
        width: 18px;
        height: 18px;
        color: ${({theme}) => theme.palette.primary.main};
    }

    &:hover {
        opacity: 1;
    }
`;

export const ActiveOptionsButton = styled(OptionsButton)`
    svg {
        color: ${({theme}) => theme.palette.primary.contrastText};
    }
`;

export const ConversationItemWrapper = styled.div<{ $active?: boolean }>`
    display: flex;
    align-items: center;

    background: ${({ $active, theme }) =>
            $active ? theme.palette.primary.main : 'transparent'};

    color: ${({ $active, theme }) =>
            $active ? theme.palette.primary.contrastText : theme.palette.text.primary};
    
    pointer-events: auto;
    
    width: 100%;
    position: relative;
    border-radius: 20px;
    padding: 1px 0 1px 4px;
    transition: all 200ms ease;
    margin: 2px 0;


    &:hover {
        background: ${({ $active, theme }) =>
                $active ? theme.palette.primary.dark : theme.palette.action.hover};
    }
    
    &:hover ${OptionsButton}, &:hover ${ActiveOptionsButton} {
        visibility: visible;
    }

    ${OptionsButton} {
        svg {
            color: ${({ $active, theme }) =>
                    $active ? theme.palette.primary.contrastText : theme.palette.text.primary};
        }
    }
`;
